class WIquickAdd extends HTMLElement {
  constructor() {
    super();
    this.allVariants = [];
    this.variantIdInput = null;
    this.productURL = '';
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Initialize data and events
    const scriptTag = this.querySelector('#card-variant-data');
    if(scriptTag)this.allVariants = JSON.parse(scriptTag.textContent);
    this.variantIdInput = this.querySelector('#selected-variant-id');
    this.setupEventListeners();
    this.mainImage = this.querySelector('.card-main-img');
    this.productOption = this.querySelector('.option-view-btn');
    if(this.productOption)this.productURL = this.productOption.getAttribute('href').split('?');
    this.onLoadCard();
  }

  setupEventListeners() {
    const optionRadios = this.querySelectorAll('.single-option input[type="radio"]');
    optionRadios.forEach(radio => {
      radio.addEventListener('change', () => this.onOptionChange());
    });
  }

  onLoadCard(){
    const singleOptionDivs = this.querySelectorAll('.single-option');
    let selectedValues = [];
  
    // Collect default selected values for each option
    selectedValues = Array.from(singleOptionDivs, optionDiv => {
      const checkedRadio = optionDiv.querySelector('input[type="radio"]:checked');
      return checkedRadio ? checkedRadio.value : null;
    });
  
    // Find the matching variant
    const matchedVariant = this.allVariants.find(variant => {
      return variant.options.every((option, index) => option === selectedValues[index]);
    });
  
    // Update the variant input or handle errors
    if (matchedVariant) {
      if (this.productOption) {
        this.querySelector('.option-view-btn').setAttribute('href', this.productURL[0] + '?variant=' + matchedVariant.id);
      }
      this.variantIdInput.value = matchedVariant.id;
  
      // Hide all variant images and display the matching one
      this.querySelectorAll('.variant-images img').forEach(e => e.style.display = 'none');
      let selectedVarImg = this.querySelector(`.variant-images img[data-variant-id="${matchedVariant.id}"]`);
      let card_main = this.querySelector('.card-main-img');
      if (selectedVarImg) {
        selectedVarImg.style.display = 'block';
        if(card_main)this.querySelector('.card-main-img').style.display = 'none';
      } else {
        if(card_main)this.querySelector('.card-main-img').style.display = 'block';
      }
    } else {
      console.log('No matching variant found');
    }
  }

  onOptionChange() {
    const singleOptionDivs = this.querySelectorAll('.single-option');
    let selectedValues = [];

    // Collect selected values for each option
    selectedValues = Array.from(singleOptionDivs, optionDiv => {
      const checkedRadio = optionDiv.querySelector('input[type="radio"]:checked');
      return checkedRadio ? checkedRadio.value : null;
    });

    // Find the matching variant
    const matchedVariant = this.allVariants.find(variant => {
      return variant.options.every((option, index) => option === selectedValues[index]);
    });

    // Update the variant input or handle errors
    if (matchedVariant) {
      if(this.productOption)this.querySelector('.option-view-btn').setAttribute('href', this.productURL[0] +'?variant=' + matchedVariant.id);
      this.variantIdInput.value = matchedVariant.id;
      this.querySelectorAll('.variant-images img').forEach(e => e.style.display = 'none');
      let selectedVarImg = this.querySelector(`.variant-images img[data-variant-id="${matchedVariant.id}"]`);
      let card_main = this.querySelector('.card-main-img');
      if(selectedVarImg){
        selectedVarImg.style.display = 'block';
        if(card_main)card_main.style.display = 'none';
      }else{
        if(card_main)card_main.style.display = 'block';
      }
      if(matchedVariant.available){
        this.querySelector('.card__stock-text .inStock').style.display = 'inline';
        this.querySelector('.card__stock-text .outStock').style.display = 'none';
      }else{
        this.querySelector('.card__stock-text .inStock').style.display = 'none';
        this.querySelector('.card__stock-text .outStock').style.display = 'inline';
      }
    } else {
      console.log('No matching variant found');
    }
  }
}

customElements.define("card-product-variants", WIquickAdd);
